import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SegmentEdit = lazy(() => import("@segments/segmenter/components/SegmentEdit/SegmentEditForNro"));

export const segmentEditNRO: NavigationRoutingObject = {
  section: "audience",
  Component: SegmentEdit,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("segment-edit-nro-heading", "Edit Segment"),
  pageNameForTracking: () => "Edit Segment",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("segment-edit-nro-description", "Edit your segment to target a specific set of users"),
  icon: "nav-system-segments",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/segmenter/segmenter/:appGroupId",
};
